export default __webpack_public_path__ + "static/media/landscapeLarge.5139be7f.jpg";